import { Observable, observe, Scope } from 'wdc-cube'
import { SerasaPersonRow } from './serasa.pf.types'
import { DadosEmpresaRow } from './serasa.pj.types'
import { BusinessReport } from './serasa.experian.business.types'
import { PersonReport } from './serasa.experian.person.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class SerasaScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() person = {} as SerasaPersonRow
    @observe() empresa = {} as DadosEmpresaRow
    @observe() experianEmpresa = {} as BusinessReport
    @observe() experianPessoa = {} as PersonReport
    @observe() cpfCnpjSelected = ''
    @observe() typeSelected = 'motor'

    onFind = Scope.ASYNC_ACTION
}

export default SerasaScope
